<section id="why">
  <div class="container">
    <div class="text-center" appReveal>
      <div class="sec-label">Por qué CradleResident</div>
      <h2 class="sec-title" style="max-width:640px;margin:0 auto 1rem">Tecnología, servicio y compatibilidad</h2>
      <p class="sec-sub mx-auto">Los pilares que respaldan cada fraccionamiento que confía en nosotros.</p>
    </div>
    <div class="row g-4 mt-4">
      <div class="col-md-4">
        <div class="why-glass h-100" appReveal>
          <div class="why-ico"><svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></svg></div>
          <h4>99.9% disponibilidad</h4>
          <p>Infraestructura en AWS y Google Cloud para operación continua.</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="why-glass h-100" appReveal>
          <div class="why-ico"><svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg></div>
          <h4>Soporte y capacitación</h4>
          <p>Atención directa por WhatsApp y capacitación incluida en todos los planes.</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="why-glass h-100" appReveal>
          <div class="why-ico"><svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg></div>
          <h4>3 plataformas móviles</h4>
          <p>Disponible en App Store, Google Play y Huawei AppGallery.</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="why-glass h-100" appReveal>
          <div class="why-ico"><svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M18 8h1a4 4 0 0 1 0 8h-1"/><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg></div>
          <h4>Notificaciones push en tiempo real</h4>
          <p>Alertas instantáneas en el celular de cada acceso, pago recibido o actividad importante.</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="why-glass h-100" appReveal>
          <div class="why-ico"><svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></div>
          <h4>Control total de accesos</h4>
          <p>Panel integrado para conectar lectores QR, RFID y UHF con barreras, plumas y cerraduras eléctricas.</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="why-glass h-100" appReveal>
          <div class="why-ico"><svg width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg></div>
          <h4>Roles diferenciados</h4>
          <p>Permisos específicos para residentes, administradores y vigilantes.</p>
        </div>
      </div>
    </div>
  </div>
</section>
